<template>
  <div>
    <h2>教学课件</h2>
    <div class="tab-box">
      <button :class="{active:currentTab==='ppt'}" @click="currentTab='ppt'">课件</button>
      <button :class="{active:currentTab==='discuss'}" @click="currentTab='discuss'">讨论</button>
      <button :class="{active:currentTab==='preview'}" @click="currentTab='preview'">课后预习</button>
    </div>

    <div v-if="currentTab === 'ppt'">
      <div class="pdf-container">
        <iframe
            :src="pdfUrl"
            width="100%"
            height="650px"
            frameborder="0"
        ></iframe>
        <div v-if="!pdfUrl" class="empty-tip">
          课件加载中或暂无课件
        </div>
      </div>
    </div>

    <div v-if="currentTab==='discuss'" class="tab-content">
      <h3>课堂讨论</h3>
      <textarea v-model="discussText" rows="8" style="width:100%;box-sizing:border-box;" readonly></textarea>
    </div>

    <div v-if="currentTab==='preview'" class="tab-content">
      <h3>课后预习</h3>
      <textarea v-model="previewText" rows="8" style="width:100%;box-sizing:border-box;" readonly></textarea>
    </div>

    <div v-if="allFinished" style="margin-top:30px;text-align:right;">
      <button @click="goPostTest" style="padding:8px 20px;background:#67C23A;color:#fff;border:none;border-radius:4px;cursor:pointer;">
        全部课程已学习完毕，前往后测问卷
      </button>
    </div>
  </div>
</template>

<script>
import { getCourseDetail, saveCourseVisit, getUserProgress } from '@/api/course'
export default {
  name:'CourseWare',
  data(){
    return {
      currentTab:'ppt',
      discussText:'',
      previewText:'',
      pptTitle:'',
      pdfUrl: '',
      courseList: [
        '/course/basic',
        '/course/acute',
        '/course/subacute',
        '/course/homeRehab'
      ],
      visited: [],
      allFinished: false
    }
  },
  created(){
    this.setChapterContent()
    this.loadUserProgress()
    this.recordCourse()
  },
  watch:{
    '$route.path'(){
      this.setChapterContent()
      this.loadUserProgress()
      this.recordCourse()
    }
  },
  methods:{
    // 从后端拉取用户学习进度
    async loadUserProgress(){
      try {
        const res = await getUserProgress()
        if(res.code === 200){
          this.visited = res.data.finishedList
          this.allFinished = res.data.allFinished
        }
      } catch (err) {
        console.error("获取课程进度失败", err)
      }
      // 已移除 await this.recordCourse()，不再在这里触发保存
    },

    async setChapterContent(){
      const path = this.$route.path
      const courseKey = path.split('/course/')[1]
      const localMap = {
        'basic':{
          pdfUrl:"",
          discussText:"舌癌手术造成哪些解剖结构破坏，会带来哪些功能损伤？",
          previewText:"预习舌癌TNM分期、各类手术术式特点"
        },
        'acute':{
          pdfUrl:"",
          discussText:"从手术结构损伤预判患者后续会出现哪些吞咽、言语、运动障碍？",
          previewText:"预习术后急性期各类管理措施"
        },
        'subacute':{
          pdfUrl:"",
          discussText:"舌癌术后亚急性期吞咽障碍如何进行分层康复训练？",
          previewText:"预习张口受限、吞咽、语音康复训练方案"
        },
        'homeRehab':{
          pdfUrl:"",
          discussText:"口腔癌术后居家康复有哪些依从性阻碍，该如何干预？",
          previewText:"学习居家训练模块、随访监测、社区康复延续管理要点"
        }
      }

      try{
        const res = await getCourseDetail(courseKey)
        if(res.code ===200){
          this.pdfUrl = res.data.pptContent
          this.pptTitle = res.data.title
          this.discussText = res.data.discussQuestion
          this.previewText = res.data.previewTip
        }else{
          const local = localMap[courseKey]
          if(local){
            this.pdfUrl = local.pdfUrl
            this.discussText = local.discussText
            this.previewText = local.previewText
          }
        }
      }catch(err){
        console.error("获取课程详情失败",err)
        const local = localMap[courseKey]
        if(local){
          this.pdfUrl = local.pdfUrl
          this.discussText = local.discussText
          this.previewText = local.previewText
        }
      }
    },

    // 提交当前课程访问记录到后端
    async recordCourse(){
      const curPath = this.$route.path
      if(this.courseList.includes(curPath) && !this.visited.includes(curPath)){
        try {
          const courseKey = curPath.split('/course/')[1]
          await saveCourseVisit({ courseKey: courseKey })
          // 已移除 await this.loadUserProgress()，保存后不再回调拉取进度
        } catch (e) {
          console.error("保存课程访问记录失败", e)
        }
      }
    },

    goPostTest(){
      alert('恭喜你完成所有课程学习，请完成后测问卷')
      this.$router.push('/survey/post-test')
    }
  }
}
</script>

<style scoped>
.tab-box button{
  padding:8px 16px;
  margin-right:6px;
  border:1px solid #ccc;
  background:#fff;
  cursor:pointer;
}
.tab-box button.active{
  background:#409eff;
  color:#fff;
  border-color:#409eff;
}
.tab-content{
  margin-top:16px;
}
.pdf-container {
  width: 100%;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
}
.empty-tip {
  text-align: center;
  padding: 100px 0;
  color: #999;
}
</style>